/*
import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')
*/
import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { FontAwesomeIcon } from './fontAwesome';
import Vue3ConfirmDialog from '@zapadale/vue3-confirm-dialog'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'


const vuetify = createVuetify({
  components,
  directives,
})

const app = createApp(App);//.mount('#app');
app.component('font-awesome-icon', FontAwesomeIcon);
app.use(Toast, {
    // You can set your default options here
    position: POSITION.TOP_CENTER
  });
app.use(Vue3ConfirmDialog);
app.use(vuetify);
app.mount('#app');